import { Size } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';

import styles from './Message.scss';

export type MessageSpacingSize = Size.XXSmall | Size.XSmall | Size.Small | Size.Medium | Size.Large;

export interface Props {
  message: React.ReactNode;
  size?: MessageSpacingSize;
  children?: React.ReactNode;
}

const Message: React.FC<Props> = ({ message, size = Size.Large, children }) => {
  const sizeClass = `wrapper${size[0].toUpperCase()}${size.slice(1)}`;
  return (
    <div
      className={classNames(styles.wrapper, { [styles[sizeClass as keyof typeof styles]]: size })}
    >
      <div data-testid="sports-message" className={styles.message}>
        {message}
      </div>
      {children}
    </div>
  );
};

export { Message };
